import { ICommandBase } from '@/commands/interface/iCommandBase';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';
import { Design } from '@/model/document2/page/surface/design/design';

// 曲線レイヤーの制御点移動コマンド
export class MoveCurveControlPointCommand implements ICommandBase
{
    private layer! : CurveLayer;
    private index! : number;
    private x! : number;
    private y! : number;
    private doneCallback! : () => void;

    private srcX : number = 0;
    private srcY : number = 0;

    constructor(layer : CurveLayer, index : number, x : number, y : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.x = x;
        this.y = y;
        this.doneCallback = doneCallback;
        // 以前の値保持
        this.srcX = this.layer.getControlPoint(index).x;
        this.srcY = this.layer.getControlPoint(index).y;
    }

    public do() : void
    {
        // 移動
        this.layer.moveControlPoint(this.index, this.x, this.y);

        this.doneCallback();
    }

    public undo() : void
    {
        // 以前の位置に移動
        this.layer.moveControlPoint(this.index, this.srcX, this.srcY);

        this.doneCallback();
    }

    public redo() : void
    {
        // 移動
        this.layer.moveControlPoint(this.index, this.x, this.y);

        this.doneCallback();
    }
}